// extracted by mini-css-extract-plugin
export var arrow = "RaceMeetingHeader-module--arrow--5bd21";
export var blue = "#0eb3f2";
export var caret = "RaceMeetingHeader-module--caret--5ede9";
export var container = "RaceMeetingHeader-module--container--70117";
export var country = "RaceMeetingHeader-module--country--c4a72";
export var emphasis = "RaceMeetingHeader-module--emphasis--20214";
export var green = "#57d33b";
export var greenLink = "RaceMeetingHeader-module--green-link--cbda5";
export var grey = "var(--tone-mid)";
export var icon = "RaceMeetingHeader-module--icon--406da";
export var indicator = "RaceMeetingHeader-module--indicator--744b8";
export var isSelected = "RaceMeetingHeader-module--isSelected--17851";
export var meeting = "RaceMeetingHeader-module--meeting--668b4";
export var meetings = "RaceMeetingHeader-module--meetings--5c4d7";
export var notchGap = "32px";
export var orange = "#f8662b";
export var popover = "RaceMeetingHeader-module--popover--ae261";
export var red = "#ff2741";
export var scrollArea = "RaceMeetingHeader-module--scrollArea--1430a";
export var suggestedVenue = "RaceMeetingHeader-module--suggestedVenue--ba241";
export var title = "RaceMeetingHeader-module--title--e98f8";
export var trigger = "RaceMeetingHeader-module--trigger--d4833";
export var venue = "RaceMeetingHeader-module--venue--29451";
export var weather = "RaceMeetingHeader-module--weather--a6070";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";